<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="less">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
}
::-webkit-scrollbar {
  display: none;
  width: 0 !important;
}
::-webkit-scrollbar {
  display: none;
  width: 0 !important;
  height: 0;
}
@-moz-document url-prefix() {
  html,
  body {
    scrollbar-width: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue